import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const paymentReceiptFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.paymentReceipt, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
